import * as React from 'react'
const CellPhoneIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M7.12 11.5a.44.44 0 000 .88h1.76a.44.44 0 000-.88z" className="-secondary-color" fill="#d7dae0"/>
      <path d="M5.38 1a1.75 1.75 0 00-1.76 1.75v10.5A1.75 1.75 0 005.38 15h5.24a1.75 1.75 0 001.76-1.75V2.75A1.75 1.75 0 0010.62 1zM4.5 2.75a.87.87 0 01.88-.87h5.24a.87.87 0 01.88.87v10.5a.88.88 0 01-.88.88H5.38a.88.88 0 01-.88-.88z" className="-secondary-color" fill="#d7dae0" fillRule="evenodd"/>
    </svg>
    
  )
}

export default CellPhoneIcon